//utilities import
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import APIURL from "../APIURL";
import useSWR from "swr";
import axios from "axios";
import { Prompt } from "react-router-dom";
import moment from "moment";
//kendo Component
import { Loader } from "@progress/kendo-react-indicators";
import { pencilIcon, trashIcon, downloadIcon } from "@progress/kendo-svg-icons";
import { Button } from "@progress/kendo-react-buttons";
import { Fade } from "@progress/kendo-react-animation";
import { SvgIcon } from "@progress/kendo-react-common";
import { Dialog } from "@progress/kendo-react-dialogs";
import { Tooltip } from "@progress/kendo-react-tooltip";
import { TabStrip, TabStripTab } from "@progress/kendo-react-layout";
import { Card, CardHeader } from "@progress/kendo-react-layout";
import { RadioButton } from "@progress/kendo-react-inputs";
import {
  Grid as GridTelerik,
  GridColumn as Column,
  GridToolbar,
} from "@progress/kendo-react-grid";
import {
  RequiredFormTextArea,
  RequiredFormDatePicker,
} from "../common/Kendo/form-components";
import { requiredValidator } from "../common/Kendo/validators";
import { Form, Field, FormElement } from "@progress/kendo-react-form";

import {
  Notification,
  NotificationGroup,
} from "@progress/kendo-react-notification";
//component
import ApproveStudySubject from "../studysubject/ApproveStudySubject";
import TrialMap from "../studysubject/TrialMap";
import AddFile from "../common/commoncomponents/AddFile";
import PermissionDenied from "../common/commoncomponents/PermissionDenied";
import DeleteObject from "../common/commoncomponents/DeleteObject";
import AddNote from "../common/commoncomponents/AddNote";
import TabChange from "../common/commoncomponents/TabChange";
import GlobalNotificationTimer from "../common/commoncomponents/GlobalNotificationTimer";
//localization
import { useLocalization } from "@progress/kendo-react-intl";

export function InformedStudySubject(props) {
  //redux
  const UserDetail = useSelector((state) => state.UserDetail);
  const EditSubject = useSelector((state) => state.EditSubject);

  //localization
  const localizationService = useLocalization();

  const [approvedformchanged, setapprovedformchanged] = useState(false);

  //variables
  const [loading, setLoading] = useState(false);
  const [approved, setApproved] = useState(false);
  const MyForm = React.createRef(); //form ref to detect modification of the form
  const [AllData, setAllData] = useState(null);
  const [EditNote, setEditNote] = useState([]); //to transfer data  edit note
  const [radioValue, setradioValue] = useState("no");

  //data
  const { data, error } = useSWR(
    props.location.state
      ? APIURL + `/common/detailsubject/${props.location.state.data.id}/`
      : null
  );
  //notes data
  const fetcher2 = (url) =>
    axios
      .get(url, {
        params: {
          subject: props.location.state.data.id,
          section: props.location.state.section.id,
        },
      })
      .then((res) => res.data);

  const { data: notes, Noteserror } = useSWR(
    props.location.state
      ? [
          APIURL + "/common/listnote/",
          props.location.state.data.id,
          props.location.state.section.id,
        ]
      : null,
    fetcher2
  );

  const { data: checkapprove, checkapproveerror } = useSWR(
    props.location.state
      ? [
          APIURL + `/common/checkapprove/`,
          props.location.state.data.id,
          props.location.state.section.id,
        ]
      : null,
    fetcher2
  );

  //attachements data
  const fetcher4 = (url) =>
    axios
      .get(url, {
        params: {
          subject: props.location.state.data.id,
          section: props.location.state.section.id,
        },
      })
      .then((res) => res.data);

  const { data: attachements, Attchementserror } = useSWR(
    props.location.state
      ? [
          APIURL + "/common/listfile/",
          props.location.state.data.id,
          props.location.state.section.id,
        ]
      : null,
    fetcher4
  );

  useEffect(() => {
    if (data) {
      setAllData(data);

      setradioValue(data.informed == false ? "no" : "yes");
    }
    if (checkapprove) {
      setApproved(checkapprove);
    }
  }, [data, checkapprove]);

  // Notification
  const [ErrorNotification, setErrorNotification] = useState("");
  const position = {
    topCenter: {
      top: 0,
      left: "50%",
      transform: "translateX(-50%)",
    },
  };

  const [state, setState] = React.useState({
    success: false,
    nosave: false,
    deleted: false,
    nomodify: false,
  });

  const onToggle = (flag) => setState({ ...state, [flag]: !state[flag] });

  const { success, nosave, deleted, nomodify } = state;

  //Permission dialog
  const [VPermission, setVPermission] = useState(false);

  const toggleDPermission = () => {
    setVPermission(!VPermission);
  };

  //Dialog for tabstrip change
  const [selectedTab, setSelectedTab] = useState(null);
  const [VTabStripChange, setVTabStripChange] = useState(false);

  const toggleDTabStripChange = () => {
    setVTabStripChange(!VTabStripChange);
  };

  //TAB STRIP
  const [selected, setSelected] = React.useState(0);

  const handleSelect = (e) => {
    if (selected === 1) {
      if (approvedformchanged === true) {
        setSelectedTab(e.selected);
        toggleDTabStripChange();
      } else {
        setSelected(e.selected);
      }
    } else if (
      MyForm.current &&
      Object.keys(MyForm.current.modified).length !== 0
    ) {
      setSelectedTab(e.selected);
      toggleDTabStripChange();
    } else {
      setSelected(e.selected);
    }
  };

  const [Subselected, setSubSelected] = React.useState(0);

  const handleSubSelect = (e) => {
    setSubSelected(e.selected);
  };

  //date template
  const DateCreatedTemplate = (dataItem) => {
    return (
      <td>
        {moment(dataItem.dataItem.date_created).format("YYYY-MM-DD HH:mm")}
      </td>
    );
  };

  //prompt function to trigger any change
  const PromptFunction = (formRenderProps) => {
    let boolean = false;
    if (formRenderProps.modified) {
      boolean = true;
    } else {
      boolean = false;
    }

    return boolean;
  };

  //callback function to send state from child to parent
  const TabCallBack = (value) => {
    setSelected(value);
  };

  //dialog for deleting object
  const [DeleteAPI, setDeleteAPI] = useState("");
  const [Name, setName] = useState("");
  const [Vdelete, setVdelete] = useState(false);

  const toggleDdelete = () => {
    setVdelete(!Vdelete);
  };

  //dialog for adding and updating files :
  const [VaddFile, setVaddFile] = useState(false);

  const toggleDaddFile = () => {
    setVaddFile(!VaddFile);
  };

  //dialog for adding and updating and deleting notes
  const [VaddNote, setVaddNote] = useState(false);

  const toggleDaddNote = () => {
    setVaddNote(!VaddNote);
  };
  const [VeditNote, setVeditNote] = useState(false);

  const toggleDeditNote = () => {
    setVeditNote(!VeditNote);
  };

  //tooltip
  const TooltipContentTemplate = (props) => {
    return (
      <div className="custom-tooltip">
        <strong>{props.title}</strong>
      </div>
    );
  };

  //NoteNameTemplate
  const NoteNameTemplate = (dataItem) => {
    return dataItem.dataItem.note.length > 20 ? (
      <td style={{ cursor: "pointer" }}>
        <Tooltip
          openDelay={0}
          tooltipStyle={{
            width: "200px",
            textAlign: "center",
          }}
          content={(props) => <TooltipContentTemplate title={props.title} />}
          anchorElement="target"
          position="top"
          parentTitle={true}
        >
          <div title={dataItem.dataItem.note}>
            {dataItem.dataItem.note.slice(0, 20)}
            {"..."}
          </div>
        </Tooltip>
      </td>
    ) : (
      <td>
        {" "}
        <div>{dataItem.dataItem.note}</div>
      </td>
    );
  };

  //NOTE ACTIONS
  const Noteactions = (dataItem) => {
    return (
      <td>
        <div className="row">
          <div className="col-6">
            <SvgIcon
              className="EditActionButtons"
              icon={pencilIcon}
              onClick={() => {
                setEditNote(dataItem.dataItem);
                EditSubject ? toggleDeditNote() : toggleDPermission();
              }}
            />
          </div>
          <div className="col-6">
            <SvgIcon
              className="DeleteActionButtons"
              icon={trashIcon}
              onClick={() => {
                setDeleteAPI(`/common/updatenote/${dataItem.dataItem.id}/`);
                setName(dataItem.dataItem.note);
                EditSubject ? toggleDdelete() : toggleDPermission();
              }}
            />
          </div>
        </div>
      </td>
    );
  };

  //FILE RELATED ACTIONS
  const Fileactions = (dataItem) => {
    return (
      <td>
        <div className="row">
          <div className="col-6">
            <SvgIcon
              svgStyle={{ cursor: "pointer", color: "grey" }}
              icon={downloadIcon}
              onClick={() => {
                EditSubject
                  ? DownloadFile(dataItem.dataItem.id, dataItem.dataItem.title)
                  : toggleDPermission();
              }}
            />
          </div>
          <div className="col-6">
            <SvgIcon
              svgStyle={{ cursor: "pointer", color: "red" }}
              icon={trashIcon}
              onClick={() => {
                setDeleteAPI(`/common/updatefile/${dataItem.dataItem.id}/`);
                setName(dataItem.dataItem.title);
                EditSubject ? toggleDdelete() : toggleDPermission();
              }}
            />
          </div>
        </div>
      </td>
    );
  };

  const DownloadFile = (id, title) => {
    axios
      .get(APIURL + `/common/downloadfile/${id}/`, {
        responseType: "blob",
      })
      .then((res) => {
        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", title);
        document.body.appendChild(link);
        link.click();
      });
  };

  //goback function

  const goBack = (event) => {
    if (event.type === "click") {
      props.history.push("/crf/studysubject/list");
    }
  };

  //radios
  const OnNoChange = (e, formRenderProps) => {
    setradioValue(e.value);
    formRenderProps.onChange("informed_date", { value: null });
  };
  const OnYesChange = (e, formRenderProps) => {
    setradioValue(e.value);
    formRenderProps.onChange("notinformed_reason", { value: "" });
  };
  //function to update subject
  const UpdateSubject = (dataItem) => {
    if (dataItem.isValid) {
      setLoading(true);
      if (dataItem.isModified) {
        axios
          .put(APIURL + "/common/informedsubjectupdate/" + data.id + "/", {
            informed: radioValue === "no" ? false : true,
            informed_date: dataItem.values.informed_date
              ? moment(dataItem.values.informed_date).format("YYYY-MM-DD")
              : null,
            notinformed_reason: dataItem.values.notinformed_reason,
            section: props.location.state.section.id,
            modified_by: UserDetail.id,
          })
          .then((res) => {
            onToggle("success");
            setTimeout(() => {
              setState({ ...state, success: false });
              setLoading(false);
            }, GlobalNotificationTimer);
          })
          .catch((error) => {
            setErrorNotification(error.response.status);
            onToggle("nosave");
            setTimeout(() => {
              setState({ ...state, nosave: false });
              setLoading(false);
            }, GlobalNotificationTimer);
          });
      } else {
        onToggle("nomodify");
        setLoading(false);
        setTimeout(() => {
          setState({ ...state, nomodify: false });
        }, GlobalNotificationTimer);
      }
    }
  };

  const disableFunction = () => {
    let boolean = false;
    if (!EditSubject || approved || loading) {
      boolean = true;
    }
    return boolean;
  };

  const ChangeApproveSection = () => {
    setapprovedformchanged(true);
  };

  const disabletitle = () => {
    let title = "";
    if (!EditSubject && approved) {
      title = localizationService.toLanguageString("custom.nopermissiontoedit");
    }
    if (!EditSubject) {
      title = localizationService.toLanguageString("custom.nopermissiontoedit");
    } else if (approved) {
      title = localizationService.toLanguageString(
        "custom.thesectionhasbeenapproved"
      );
    } else {
      title = localizationService.toLanguageString("custom.savechanges");
    }
    return title;
  };
  //SWR ESSENTIAL
  if (!data && !notes && !attachements)
    return (
      <>
        <Loader type="converging-spinner" />
      </>
    );

  const loadingPanel = (
    <div className="k-loading-mask">
      <span className="k-loading-text">
        {localizationService.toLanguageString("custom.loading")}
      </span>
      <div className="k-loading-image"></div>
      <div className="k-loading-color"></div>
    </div>
  );

  if ((error, Noteserror && Attchementserror))
    return <>{localizationService.toLanguageString("custom.failedload")}</>;

  return (
    <TrialMap>
      {(!data || !notes || !attachements) && loadingPanel}
      <div className="row">
        <div className="col-12">
          <Card>
            <CardHeader className="DetailFormHeader">
              <div className="row">
                <div className="col DetailCardElementTitle">
                  {localizationService.toLanguageString("custom.subjectid")}
                </div>
                <div className="col DetailCardElementTitle">
                  {localizationService.toLanguageString(
                    "custom.subjectinitials"
                  )}
                </div>
                <div className="col DetailCardElementTitle">
                  {localizationService.toLanguageString("custom.study")}
                </div>
                <div className="col DetailCardElementTitle">
                  {localizationService.toLanguageString("custom.protocolid")}
                </div>
                <div className="col DetailCardElementTitle">
                  {localizationService.toLanguageString("custom.sitenumber")}
                </div>
                <div className="col DetailCardElementTitle">
                  {localizationService.toLanguageString("custom.createdby")}
                </div>
              </div>
              <div className="row">
                <div className="col text-responsive-overflow subject-id-style">
                  {props.location.state ? props.location.state.data.crf_id : ""}
                </div>
                <div className="col text-responsive-overflow">
                  {props.location.state
                    ? props.location.state.data.subject_initial
                    : ""}
                </div>
                <div className="col text-responsive-overflow">
                  {props.location.state
                    ? props.location.state.data.study_name
                    : ""}
                </div>
                <div className="col text-responsive-overflow">
                  {props.location.state
                    ? props.location.state.data.study_protocol
                    : ""}
                </div>
                <div className="col text-responsive-overflow">
                  {props.location.state
                    ? props.location.state.data.subject_center
                    : ""}
                </div>
                <div className="col text-responsive-overflow">
                  {props.location.state
                    ? props.location.state.data.createdBy
                    : ""}
                </div>
              </div>
              <hr className="RowRoleHr" />
              <div className="row">
                <div className="col pages-big-title">
                  <strong>
                    {localizationService.toLanguageString(
                      "custom.informedconsent"
                    )}
                  </strong>
                </div>
                <div className="col">
                  <div className="float-right">
                    <Button onClick={goBack} className="back-button-style">
                      {localizationService.toLanguageString("custom.back")}
                    </Button>
                  </div>
                </div>
              </div>
            </CardHeader>
          </Card>
        </div>
      </div>
      <div className="row mt-2">
        <div className="col-12">
          <TabStrip selected={selected} onSelect={handleSelect}>
            <TabStripTab
              title={localizationService.toLanguageString(
                "custom.informedconsent"
              )}
            >
              <Form
                initialValues={{
                  informed_date:
                    AllData && AllData.informed_date
                      ? new Date(AllData.informed_date)
                      : null,
                  notinformed_reason:
                    AllData && AllData.notinformed_reason
                      ? AllData.notinformed_reason
                      : "",
                }}
                ref={MyForm}
                key={JSON.stringify(AllData)}
                onSubmitClick={UpdateSubject}
                render={(formRenderProps) => (
                  <FormElement>
                    <fieldset className={"k-form-fieldset"}>
                      <Tooltip
                        openDelay={0}
                        anchorElement="target"
                        parentTitle={true}
                        position={"top"}
                      >
                        <Prompt
                          when={PromptFunction(formRenderProps)}
                          message={localizationService.toLanguageString(
                            "custom.promptmessage"
                          )}
                        />
                        <div className="col-6">
                          <div className="row mt-4">
                            <div className="col-4">
                              {localizationService.toLanguageString(
                                "custom.consentobtained"
                              )}
                              ?
                            </div>
                            <div className="col-4">
                              <RadioButton
                                name="radio1"
                                value="yes"
                                onChange={(e) =>
                                  OnYesChange(e, formRenderProps)
                                }
                                checked={radioValue === "yes"}
                                label={localizationService.toLanguageString(
                                  "custom.yes"
                                )}
                                // disabled={
                                //   AllData && AllData.informed === true
                                //     ? true
                                //     : false
                                // }
                              />
                            </div>
                            <div className="col-4">
                              <RadioButton
                                name="radio1"
                                value="no"
                                checked={radioValue === "no"}
                                label={localizationService.toLanguageString(
                                  "custom.no"
                                )}
                                onChange={(e) => OnNoChange(e, formRenderProps)}
                              />
                            </div>
                          </div>
                          <div className="row">
                            <div className="col">
                              {radioValue === "no" ? (
                                <Field
                                  id={"notinformed_reason"}
                                  name={"notinformed_reason"}
                                  label={localizationService.toLanguageString(
                                    "custom.reason"
                                  )}
                                  optional={true}
                                  validator={requiredValidator}
                                  component={RequiredFormTextArea}
                                />
                              ) : (
                                <Field
                                  id={"informed_date"}
                                  name={"informed_date"}
                                  label={localizationService.toLanguageString(
                                    "custom.informeddate"
                                  )}
                                  validator={requiredValidator}
                                  component={RequiredFormDatePicker}
                                />
                              )}
                            </div>
                          </div>
                        </div>
                      </Tooltip>
                    </fieldset>
                    <Tooltip
                      openDelay={0}
                      anchorElement="target"
                      parentTitle={true}
                      position={"left"}
                    >
                      <div className="float-right">
                        <div title={disabletitle()}>
                          <Button
                            className="k-button mr-2em"
                            primary={true}
                            disabled={disableFunction()}
                          >
                            {loading
                              ? localizationService.toLanguageString(
                                  "custom.loading"
                                )
                              : localizationService.toLanguageString(
                                  "custom.save"
                                )}
                          </Button>
                        </div>
                      </div>
                    </Tooltip>
                  </FormElement>
                )}
              />
            </TabStripTab>
            <TabStripTab
              title={localizationService.toLanguageString(
                "custom.approvesection"
              )}
            >
              <ApproveStudySubject
                study_subject={props.location.state.data.id}
                section={props.location.state.section.id}
                data={props.location.state.data}
                parentCallBack={ChangeApproveSection}
              />
            </TabStripTab>
            <TabStripTab
              title={localizationService.toLanguageString(
                "custom.notesnattachements"
              )}
            >
              <TabStrip selected={Subselected} onSelect={handleSubSelect}>
                <TabStripTab
                  title={localizationService.toLanguageString("custom.notes")}
                >
                  <GridTelerik data={notes}>
                    <GridToolbar>
                      <Button
                        primary={true}
                        onClick={() => {
                          {
                            EditSubject
                              ? toggleDaddNote()
                              : toggleDPermission();
                          }
                        }}
                      >
                        {localizationService.toLanguageString("custom.new")}
                      </Button>
                    </GridToolbar>

                    <Column
                      field={"name"}
                      title={localizationService.toLanguageString(
                        "custom.name"
                      )}
                      cell={NoteNameTemplate}
                    />
                    <Column
                      field={"date_created"}
                      title={localizationService.toLanguageString(
                        "custom.datecreated"
                      )}
                      cell={DateCreatedTemplate}
                    />
                    <Column
                      title={localizationService.toLanguageString(
                        "custom.actions"
                      )}
                      width="100px"
                      cell={Noteactions}
                    />
                  </GridTelerik>
                </TabStripTab>

                <TabStripTab
                  title={localizationService.toLanguageString(
                    "custom.attachements"
                  )}
                >
                  <GridTelerik data={attachements}>
                    <GridToolbar>
                      <Button
                        primary={true}
                        onClick={() => {
                          {
                            EditSubject
                              ? toggleDaddFile()
                              : toggleDPermission();
                          }
                        }}
                      >
                        {localizationService.toLanguageString("custom.new")}
                      </Button>
                    </GridToolbar>
                    <Column
                      field={"title"}
                      title={localizationService.toLanguageString(
                        "custom.title"
                      )}
                    />

                    <Column
                      field={"date_created"}
                      title={localizationService.toLanguageString(
                        "custom.dateadded"
                      )}
                      cell={DateCreatedTemplate}
                    />

                    <Column
                      title={localizationService.toLanguageString(
                        "custom.actions"
                      )}
                      width="100px"
                      cell={Fileactions}
                    />
                  </GridTelerik>
                </TabStripTab>
              </TabStrip>
            </TabStripTab>
          </TabStrip>
        </div>
      </div>

      <NotificationGroup style={position.topCenter}>
        <Fade>
          {nosave && (
            <Notification
              type={{
                style: "error",
                icon: true,
              }}
              closable={true}
              onClose={() => setState({ ...state, nosave: false })}
            >
              <span>
                {ErrorNotification}{" "}
                {localizationService.toLanguageString("custom.errornosave")}
              </span>
            </Notification>
          )}
        </Fade>
        <Fade>
          {nomodify && (
            <Notification
              type={{
                style: "warning",
                icon: true,
              }}
              closable={true}
              onClose={() => setState({ ...state, nomodify: false })}
            >
              <span>
                {localizationService.toLanguageString(
                  "custom.nomodificationchange"
                )}
              </span>
            </Notification>
          )}
        </Fade>
        <Fade>
          {success && (
            <Notification
              type={{
                style: "success",
                icon: true,
              }}
              closable={true}
              onClose={() => setState({ ...state, success: false })}
            >
              <span>
                {localizationService.toLanguageString("custom.datasaved")}
              </span>
            </Notification>
          )}
        </Fade>
      </NotificationGroup>
      {/* PERMISSION DIALOG */}
      {VPermission && (
        <Dialog
          title={localizationService.toLanguageString(
            "custom.permissiondenied"
          )}
          onClose={toggleDPermission}
        >
          <PermissionDenied onClose={toggleDPermission} />
        </Dialog>
      )}
      {VaddNote && (
        <Dialog
          width="700px"
          title={localizationService.toLanguageString("custom.addnote")}
          onClose={toggleDaddNote}
        >
          <AddNote
            onClose={toggleDaddNote}
            section={props.location.state.section.id}
            subject={data.id}
          />
        </Dialog>
      )}
      {VeditNote && (
        <Dialog
          width="700px"
          title={localizationService.toLanguageString("custom.editnote")}
          onClose={toggleDeditNote}
        >
          <AddNote onClose={toggleDeditNote} data={EditNote} />
        </Dialog>
      )}
      {Vdelete && (
        <Dialog
          title={localizationService.toLanguageString("custom.confirm")}
          onClose={toggleDdelete}
        >
          <DeleteObject onClose={toggleDdelete} Name={Name} api={DeleteAPI} />
        </Dialog>
      )}
      {VaddFile && (
        <Dialog
          width="600px"
          title={localizationService.toLanguageString("custom.upload")}
          onClose={toggleDaddFile}
        >
          <AddFile
            onClose={toggleDaddFile}
            section={props.location.state.section.id}
            subject={data.id}
          />
        </Dialog>
      )}
      {VTabStripChange && (
        <Dialog
          title={localizationService.toLanguageString("custom.confirm")}
          onClose={toggleDTabStripChange}
        >
          <TabChange
            selected={selectedTab}
            parentCallBack={TabCallBack}
            onClose={toggleDTabStripChange}
          />
        </Dialog>
      )}
    </TrialMap>
  );
}
export default InformedStudySubject;
